export default __webpack_public_path__ + "static/media/ismt.3c30d6cf.png";